export const GLOBALEVENTNAMES = {
    CHANGE_EXEMPLARLISTEFORLIEFERPOSITION: "changeExemplarlisteForLieferpositionEvent",
    LOAD_WARENKORBDATA: "loadWarenkorbDataEvent",
    WARENKORBPOSITION_CHANGED : "warenkorbPositionChangedEvent",
    REMOVE_ENTWURF : "removeEntwurfFromWarenkorbEvent",
    SET_LINKS_TO_WEBSITE: "setLinksToWebsiteEvents"

};

export const ENTWURF_EVENTNAMES = {
    LOADEDENTWURF_INITIALIZED: "loadedEntwurfInitialized"
}

export const SELOBTAB_EVENTNAMES  = {
    DISPLAYFALLBACK : "displayFallbackSelObTabEvent",
    DISPLAYTAB : "showSelObTabEvent",
    INITTABBY : "initTabbyEvent",
    ACTIVATE_ARTIKEL_VIEW : "activateArtikelViewEvent",
    ACTIVATE_PRODUCT_VIEW : "activateProduktViewEvent",
    TABOPENED : "selObTabOpenedEvent"
};


export const CONTROLLER_EVENTNAMES = {
    CHANGESELOBWITHHISTORY : "changeSelObAndTellHistoryControllerEvent",
    ERROR : "ErrorHappenedEvent",
    PRODUCT_INITIALIZED: "PRODUCT_INITIALIZED"
};


export const HINTBOXEVENTNAMES = {
    SELOBLEAVINGSPERRBEZIRK : "selObLeavingSperrbezirkEvent",
    SELOBLEAVINGCOLLISION : "selObLeavingIllegalCollisionEvent",
    HIDEHINT : "hideHintEvent",
    SHOWHINT : "showHintEvent"
};

export const SELOBEVENTNAMES = {
    CHANGED : "selObChangedEvent",
    DELETED : "selObDeletedEvent",
    SELECTED : "selObSelectedEvent",
    CREATED : "selObCreatedEvent",
    INSERTED : "selObInsertedEvent",
    ZORDER_AVAILABLE : "zOrderAvailableEvent",
    DOUBLECLICKED : "selObWasDoubleClickedEvent",
    FLOATING_CHANGED : "selObFloatingChangedEvent",
    SELECTION_CLEARED : "selectionClearedEvent",
    CLONE_DELETED : "cloneDeletedEvent",
    INSERT_AS_PATTERN : "insertSelObAsPatternOnAllPartsEvent",
    DISPLAY_SELOB_IN_VIEWER:"displaySelObInViewerEvent",
    DELETEREQUEST : "selobDeletionRequestedEvent",
    DELETEREQUEST_WithoutHistory : "selobDeletionWithoutHistoryRequestedEvent",
    CHECK_Z_ORDERTABLE: "checkZOrderEvent",
    LOAD_KK_VORBELEGUNGSSELOBS : "loadKKSelObsEvent",
    SELECTION_REQUEST: "selObSelectionRequestEvent",
    FONTLOADINGERROR_SET_TO_DEFAULTFONT: "fontloadingerror_setToDefaultWertEvent"
};

export const WARENKORBEVENTNAMES = {
    TERMINEARRIVED : "wktermineArrivedEvent",
    PRICES_UPDATED : "updateLieferpostenPreiseEvent",
    CHANGE_PRODUKTIONSART: "changeProduktionsartEvent",
    PRODUKTIONSART_CHANGED : "produktionsartChangedEvent",
    SHOW_WARENKORB : "showWarenkorbEvent",
    UPDATE_GESAMTPREIS : "updateGesamtpreisEvent",
    UPDATE_RABATTFIELD: "updateRabattFieldEvent",
    CHECK_WARENKORB_ALLINFO_PRESENT : "checkWarenkorbEmailExitsEvent",
    EXTRACT_BASEDATA : "extractWarenkorbBaseDataEvent",
    RESET : "resetWarenkorbEvent",
    ZERORABATT_DETECTED: "zeroPercentRabattDetectedEvent",
    UPDATE_PRODTERMIN : "updateProduktionsTerminEvent",
    ADRESSES_UPDATED : "adressesUpdatedEvent",
    ZAHLART_UPDATED : "zahlartchangedEvent",
    EINZELEXEMPLARE_SAVED : "einzelexemplareSavedEvent",
    GEWICHTVOLUMEN_UPDATED : "wkGewichtVolumenUpdatedEvent",
    VERSANDART_CHANGED : "warenkorbVersandartChangedEvent",
    WARENKORB_LOADED : "warenkorbLoadedEvent",
    VERSANDKOSTEN_ARRIVED : "versandkostenArrivedEvent",
    CHANGE_VERSANDART : "changeVersandartEvent",
    LOADLIEFERTERMINE : "loadLiefertermineEvent",
    CHANGE_DESIGNCHECK : "changeDesignCheckEvent",
    DESIGNCHECK_CHANGED : "designcheckChangedEvent",
    ORDERPLACED : "orderplacedEvent",
    DESIGNCHECK_AVAILABILITY_CHANGED :"designcheckAvailabiltyChangedEvent",
    PAYMENT_PROCESS : "paymentProcessEvent",
    CHANGE_EXEMPLARLIST : "changeExemplarListEvent",
    ENTWURF_REMOVED : "entwurfRemovedEvent",
    ACTIVATE_GOTO_PRUEFUNG : "activateGotoPruefungEvent",
    SET_TERMINE_KOSTEN_NULL : "setzeTermineUndKostenAufNullEvent",
    USERCHOSEN_PAYMENTAFTERAPPROVAL_CHANGED : "userchosenPaymentafterApprovalChangedEvent",
    USERCHOSEN_PAYMENTAFTERAPPROVAL_AVAILABILITY_CHANGED :"userchosenPaymentafterApprovalAvailabilityChangedEvent",
    SET_BESTELLBUTTON_TEXT : "setzeBestellButtonText",
    DESIGNCHECK_NOT_CHOSEN_ERROR: "designcheckNotChosenEvent",
    WARENKORB_ABOUT_TO_BE_SUBMITTED: "warenkorbAboutToBeSubmittedEvent",
    VERSANDKOSTENBERECHNUNG_STARTED: "versandkostenBerechnungStartedEvent",
    UPDATE_LIEFERKOSTEN: "updateLieferkostenEvent",
    SHOW_WEITERLEITUNGSINFO: "showWeiterleitungsInfoEvent",
    PROCESS_VERSANDKOSTEN : "processVersandkostenFromWarenkorbCallerEvent"
};


export const LIEFERTERMINEEVENTNAMES  = {
    LIEFERTERMINEARRIVED : "lieferTermineArrivedAsDatesEvent",
    FILLHINWEISFELD : "fillLieferterminHinweisFeldEvent",
    LIEFERTERMINEUNDERWAY : "liefertermineUnderwayEvent",
    FILLZUSAMMENFASSUNG : "fillLieferterminZusammenfassungEvent",
    LIEFERTERMIN_AVAILABLE: "lieferterminAvailableEvent"
};

export const ADRESSENEVENTNAMES = {
    WK_ADRESSES_EQUAL : "deliveryAndBillingAdressesEqualEvent",
    WK_ADRESSES_DIFFER : "deliveryAndBillingAdressesDifferEvent",
    OPEN_KONTAKTDATEN : "openKontaktdatenEvent",
    OPEN_ADRESSAUSWAHL : "openAddressAuswahlEvent",
    SHOW_CHANGEADRESSEPOPUP : "showChangeAdressPopupEven",
    KONTAKTDATEN_ARRIVED: "kontaktdatenArrivedEvent",
    DIRECTOPEN_POPUPFORADRESSE : "openAdressPopupForAdresseEvent",
    SWITCH_ADRESSE : "switchAdresseEvent",
    CHANGE_ADRESSE: "changeAdresseEvent",
    DELETE_ADRESSE : "deleteAdresseEvent",
    SAVE_ADRESSE: "saveAdresseEvent",
    KONTAKTDATENCHANGED: "kontaktdatenChangedEvent"
};

export const FONTEVENTNAMES = {
    PRERENDERFONTEVENT : "prerenderFontEvent",
    UPDATEFONTEVENT : "updateUsedFontsEvent",
    FONTSLOADED : "fontsloadedEvent",
    RESET : "fontResetEvent",
    UPDATEFONTINSELOB : "updateFontInSelObEvent"
}
